import {Injectable} from "@angular/core";
import {
  ProductBackorderStatus,
  ProductStockStatus,
  ProductVariantStatus
} from "../../ecommerce-product.enum";
import {FormArray, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {EcommerceService} from "../../ecommerce.service";
import {
  IVariation
} from "./add-product-form.interface";
import {ProductAddHelperService} from "./product-add-helper.service";


@Injectable()
export class ProductVariantsHelper {
  variants: IVariation[];
  variantsForm: FormGroup;
  productForm: FormGroup;
  defaultFormValue;

  get variantsFormArray(): FormArray {
    return this.variantsForm.get('variants') as FormArray;
  }

  constructor(private _fb: FormBuilder,
              private _productAddHelper: ProductAddHelperService,
              private _ecommerceService: EcommerceService) {
  }

  public combineOptions(arrays: any[]): Array<{ name: string }[]> {
    const optionValues = arrays
      .map(obj => obj.option_value)
      .filter(options => Array.isArray(options) && options.length > 0);

    return optionValues.reduce((acc, values) => {
      if (acc.length === 0) {
        return values.map(value => {
          return [value];
        });
      } else {
        return acc.flatMap(combination =>
          values.map(value => [...combination, value])
        );
      }
    }, []);
  }

  public addVariants(optionsList: Array<{ name: string }[]>) {
    console.log(this.variants);
    optionsList.map((optionArray, index) => {
      const variantData: any = {};
      const variant = this.variants && this.variants[index];
      if (variant) {
        variantData.id = variant.id;
        variantData.status = variant.status;
        variantData.image = variant.image;
        variantData.stock_status = variant.stock_status;
        variantData.stock_quantity = variant.stock_quantity;
        variantData.price = variant.regular_price || variant.price;
        variantData.sale_price = variant.sale_price;
        variantData.backorder_status = variant.backorder_status || variant.backorders;
        variantData.stock_quantity = variant.stock_quantity;
        variantData.height = variant.dimensions?.height;
        variantData.weight = variant.weight;
        variantData.width = variant.dimensions?.width;
        variantData.length = variant.dimensions?.length;
        variantData.sku = variant.sku;
      }

      const newForm = this.createVariantsForm();
      const data = {
        options: optionArray,
      };
      newForm.patchValue({...data, ...this._getMainPriceFormValue(), ...variantData});
      const variantForm = this.variantsFormArray.at(index);
      if (variantForm) {
        variantForm.patchValue(newForm);
        // here to prevent status to change VALID
        variantForm.get('status')?.setValue(newForm.get('status').value);
      } else {
        this.variantsFormArray.push(newForm);
      }
    });
    this.defaultFormValue = this.variantsForm.getRawValue();
  }

  private _getMainPriceFormValue() {
    const formGroup = this.productForm.get('pricing_group') as FormGroup;
    return formGroup.getRawValue();
  }

  clearVariantsArray() {
    while (this.variantsFormArray.length !== 0) {
      this.variantsFormArray.removeAt(0);
    }
  }

  createVariantsForm() {
    const data = {
      id: null,
      checked: false,
      image: null,
      options: [],
      stock_quantity: 1,
      stock_status: ProductStockStatus.IN_STOCK,
      backorder_status: ProductBackorderStatus.DO_NOT_ALLOW,
      backorders: ProductBackorderStatus.DO_NOT_ALLOW,
      price: new FormControl('', this._productAddHelper.priceValidation),
      sale_price: new FormControl('', this._productAddHelper.priceValidation),
      available: new FormControl('', this._productAddHelper.priceValidation),
      sku: '',
      weight: '',
      height: '',
      length: '',
      width: '',
      status: ProductVariantStatus.PUBLISH
    };
    return this._fb.group(data);
  }

  filterOnlyCurrentVariants = (variants, activeAttributes) => variants.filter(variant => variant.attributes?.some(att => !!activeAttributes.some(activeAtt => att.name === activeAtt.option.label && activeAtt.option_value.some(opt => opt.name === att.option))));

}
